const React = require("react");
const T = require("prop-types");
const { default: RaisedButton } = require("material-ui/RaisedButton");
const { RadioButton, RadioButtonGroup } = require("material-ui/RadioButton");
const StarIcon = require("material-ui/svg-icons/action/grade").default;
const Classes = require("../styles.scss");
const ContentHelpers = require("utils/content-helpers");

module.exports = class PaymentOptions extends React.PureComponent {
    static propTypes = {
        currentPaymentOption: T.number,
        downloadPackage: T.shape({
            cost: T.number.isRequired,
            id: T.number.isRequired,
            name: T.string.isRequired
        }),
        numCredits: T.number.isRequired,
        onPremiumClick: T.func.isRequired,
        paymentOptionChanged: T.func.isRequired,
        paymentOptions: T.arrayOf(
            T.shape({
                id: T.number.isRequired,
                cost: T.number.isRequired,
                numCredits: T.number.isRequired,
                description: T.string.isRequired
            })
        ),
        transaction: T.shape({
            type: T.oneOf(["credits", "purchase", "upgrade"]).isRequired,
            id: T.number // Not required; exists only if a purchase or upgrade (model transaction)
        }).isRequired
    };

    constructor(props, context) {
        super(props, context);

        this.defaultSelection = this._defaultSelection.bind(this);
        this.modelTransactionContent = this._modelTransactionContent.bind(this);
    }

    get isModelTransaction() {
        return ["purchase", "upgrade"].includes(this.props.transaction.type);
    }

    get isUpgrade() {
        return this.props.transaction.type === "upgrade";
    }

    _defaultSelection() {
        const {
            currentPaymentOption,
            downloadPackage,
            paymentOptions
        } = this.props;

        // Shouldn't happen, just a failsafe
        if (currentPaymentOption) {
            return currentPaymentOption;
        }

        let select;
        if (!this.isModelTransaction) {
            // Buying credits
            select = paymentOptions.find(opt => opt.numCredits === 5).id;
        } else if (this.isUpgrade) {
            select = paymentOptions.find(opt => opt.numCredits === 1).id;
        } else {
            // For purchases, default to the payment option that matches the package's cost
            select = paymentOptions.find(
                opt => opt.numCredits === downloadPackage.cost
            ).id;
        }

        return select;
    }

    _modelTransactionContent() {
        const { downloadPackage, numCredits, transaction } = this.props;

        const cost = this.isUpgrade ? 1 : downloadPackage.cost;
        const deficit = () => {
            switch (transaction.type) {
                case "upgrade":
                    if (numCredits >= 1) {
                        throw new Error(
                            "Issue with step logic! Should be at redeem step"
                        );
                    }
                    // TODO if/when more packages added, calculate deficit as diff between
                    // original purchase package and target package cost. Not worth the effort now
                    return 1;
                    break;
                case "purchase":
                    if (numCredits >= downloadPackage.cost) {
                        throw new Error(
                            "Issue with step logic! Should be at redeem step"
                        );
                    }
                    return cost - numCredits;
                    break;
            }
        };

        return (
            <div>
                <h4>
                    {this.isUpgrade ? "Upgrading to a" : "1"}{" "}
                    {ContentHelpers.capitalize(downloadPackage.name)} Download
                    Package costs {cost} Credit{ContentHelpers.plural(cost)}.
                    {/* <a
                        target='_blank'
                        href="https://www.mybodymodel.com/see-what's-included/"
          >
                        {' '}
            Click here to see what's included
                    </a> */}
                </h4>
                {numCredits === 0 ? (
                    <h4>
                        You have no Credits in your account. Credits can be used
                        anytime and do not expire. Stock up and save to get our
                        best rates.
                    </h4>
                ) : (
                    <h4>
                        Purchase at least {deficit} Credit
                        {ContentHelpers.plural(deficit)} to{" "}
                        {this.isUpgrade
                            ? "upgrade to a"
                            : `redeem your ${cost}-Credit`}{" "}
                        {ContentHelpers.capitalize(downloadPackage.name)}{" "}
                        Download package of this body model.
                    </h4>
                )}
            </div>
        );
    }

    componentDidMount() {
        // Use previously selected value, falling back to the cost
        // of the selected download package, if any

        if (this.props.currentPaymentOption) {
            return;
        }

        // Expected to rerender this component with our internal default
        return this.props.paymentOptionChanged(null, this.defaultSelection());
    }

    render() {
        const {
            currentPaymentOption,
            downloadPackage,
            numCredits,
            onPremiumClick,
            paymentOptionChanged,
            paymentOptions,
            transaction
        } = this.props;

        return (
            <div>
                <h4>
                    {this.isModelTransaction
                        ? this.modelTransactionContent()
                        : "How many Credits would you like to purchase?  Credits can be used anytime and do not expire. Stock up and save to get our best rates:"}
                </h4>
                <RadioButtonGroup // key needed to ensure other steps e.g. downloadPackages that use this component don't accidentally reuse it
                    key={`paymentOptionsButtonGroup_selected${currentPaymentOption}`}
                    name="paymentOptionsButtonGroup"
                    defaultSelected={currentPaymentOption}
                    onChange={paymentOptionChanged}
                    className={Classes.optionsGroup}
                >
                    {/*
                    Disable any options whose purchase wouldn't leave user with sufficient credits to redeem selected package
                    Currently applies only to redeeming a Premium download package, where the 1 credit payment option is insufficient
                */}
                    {paymentOptions.map(option => (
                        // TODO Does this have to be purchase-specific? I don't think so. For upgrades: cost is diff between current and target package
                        <RadioButton
                            disabled={
                                transaction.type === "purchase" &&
                                downloadPackage.cost - numCredits >
                                    option.numCredits
                            }
                            key={`paymentOptionButton_${option.id}`}
                            value={option.id}
                            label={option.description}
                            className={`${
                                option.numCredits
                            }_credit${ContentHelpers.plural(
                                option.numCredits
                            )}`}
                        />
                    ))}
                </RadioButtonGroup>
                {this.isModelTransaction && downloadPackage.name === "basic" && (
                    <RaisedButton
                        primary
                        label={
                            <span>
                                <StarIcon
                                    color="white"
                                    style={{
                                        position: "relative",
                                        top: ".6rem",
                                        right: ".5rem"
                                    }}
                                />
                                Switch to Premium Download Package (2 Credits)
                            </span>
                        }
                        onClick={onPremiumClick}
                        labelStyle={{ textTransform: "inherit" }}
                    />
                )}
                {!this.isModelTransaction && (
                    <p>
                        Credits are saved in your Account until you’re ready to
                        spend them. A Basic Download costs 1 Credit and a
                        Premium Download costs 2 Credits.{" "}
                    </p>
                )}
                <p>
                    Expecting your measurements to change? Get a discount pack
                    and save leftover Credits for later.
                </p>
            </div>
        );
    }
};



// WEBPACK FOOTER //
// ./src/components/Dialog/TransactionDialog/PaymentOptions.js